import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { getBanners } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import BannersHeader from "./components/BannersHeader";
import BannersTableComponent from "./components/BannersTableComponent";
import BannerFiltrosComponents from "./components/BannerFiltrosComponents";
import { Backdrop, CircularProgress } from "@mui/material";

export const statusOptions = [
  { label: 'Vigentes', value: "vigentes", id: 1 },
  { label: 'Inactivos', value: "inactivos", id: 2 },
  { label: 'Todos', value: "todos", id: 3 },
];

function BannersAdminPage() {
  const [loading, setLoading] = useState(false);
  const [dataBanners, setDataBanners] = useState([]);
  const [metaPaginacion, setMetaPaginacion] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [loadingCargar, setLoadingCargar] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [idBannerDelete, setIdBannerDelete] = useState(null);
  const [showDeleteBannerModal, setShowDeleteBannerModal] = useState(false);

  const [statusFilter, setStatusFilter] = useState("todos");
  const [searchFilter, setSearchFilter] = useState("");

  const stateToken = useSelector((state) => state.reducerGlobal.token);

  let history = useNavigate();













  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (searchFilter.length > 2) {

        handleApiFiltrarCompras(1);
      } else {
        handleApiFiltrarCompras(1);
      }
    }, 1500);
    return () => clearTimeout(timeOutId);
  }, [stateToken, searchFilter, perPage]);









  // Funcion para filtrar compras por los parametros del endpoint.
  const handleApiFiltrarCompras = (page = 1) => {
    const body = {
      page: page,
      per_page: perPage,
      titulo: searchFilter,
    };

    setLoadingCargar(true);

    getBanners(stateToken?.access_token, body)
      .then((response) => {
        console.log("response==>getFiltrarCompras", response?.data);

        setDataBanners(response?.data?.data || []);
        setLoading(true);


        setMetaPaginacion({
          current_page: response?.data?.current_page,
          per_page: response?.data?.per_page,
          total: response?.data?.total,
          last_page: response?.data?.last_page
        });
        setLoadingCargar(false);
      })
      .catch((error) => {
        console.log("error==>getBanners", error);
        setDataBanners([]);
        setMetaPaginacion({
          current_page: 1,
          per_page: perPage,
          total: 0,
          last_page: 1,
        });
        setLoading(true);
        setLoadingCargar(false);
      });
  };







  //=================================================================================================funcion para ir a la pantalla de agregar
  const handleAddBanner = () => {
    history('/app/admin/banners-agregar', { state: null });
  };
















  // funcion para cambiar la cantidad de items por página
  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
  };



  const handleEditarItem = (item) => {
    console.log("usuario a editar==>", item);

    // history(`/app/admin/banners-detalle/${item?.id}`);
    history(`/app/admin/banners-editar/${item?.id}`);

  };

  //=============================================funcion para ver sin editar el banner
  const handleVerDetalle = (item) => {
    console.log('Edit', item?.id);
    history(`/app/admin/banners-detalle/${item?.id}?mode=view`);
  };


  const handleOpenModalDeleteBanner = (idBanner) => {
    setIdBannerDelete(idBanner);
    setShowDeleteBannerModal(true);
  };




  // funcion para manejar el input de búsqueda
  const handleSearchChange = (value) => {
    setSearchFilter(value);
  };


  // funcion para manejar el cambio del filtro de estado
  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };


  return (
    <HeaderCustom>
      <div className="min-h-screen bg-gray-100 p-6">
        {loading ? (
          <div className="max-w-7xl mx-auto">
            <BannersHeader
              title="Banners"
              subtitle="Administra y supervisa los banners de la plataforma."
              handleAdd={handleAddBanner}
            />

            <div>
              <BannerFiltrosComponents
                searchValue={searchFilter}
                onSearchChange={handleSearchChange}
                statusFilter={statusFilter}
                onStatusChange={handleStatusChange}
                statusOptions={statusOptions}
              />


              <BannersTableComponent
                data={dataBanners}
                metaPaginacion={metaPaginacion}
                onPageChange={handleApiFiltrarCompras}
                perPage={perPage}
                onPerPageChange={handlePerPageChange}
                handleEditarItem={handleEditarItem}
                handleVerDetalle={handleVerDetalle}
                handleOpenModalDelete={handleOpenModalDeleteBanner}
              />
            </div>



          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
            <div className="space-y-4">
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-10 bg-gray-200 rounded animate-pulse" />
              <div className="h-24 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        )}


        <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </HeaderCustom>
  );
}

export default BannersAdminPage;